import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { type JSX } from "react";

import { DynamicSessionSummary } from "./DynamicSessionSummary";
import { SessionSummary } from "./SessionSummary";
import { useSessionSummaryViewModel } from "./useSessionSummaryViewModel";

/**
 * Shared wrap-up behavior for both summary layouts. Renders the dynamic callback summary when
 * `EWP-dynamicCallbackSessionSummaryEnabled` is on, and the standard summary otherwise.
 */
export function SessionSummaryContainer(): JSX.Element {
    const viewProps = useSessionSummaryViewModel();
    const {
        features: { dynamicCallbackSessionSummaryEnabled },
    } = useFeatures<WorkspaceFeatures>();

    if (dynamicCallbackSessionSummaryEnabled) {
        return <DynamicSessionSummary {...viewProps} />;
    }

    return <SessionSummary {...viewProps} />;
}
